export default function PHP_AjaxPHP() {
  return (
    <div>
      <h1>PHP_AjaxPHP</h1>
    </div>
  );
}
